<template>
  <v-container>
    <v-card
      color="#efefef"
      class="mb-12"
    >
      <v-row class="px-5 ">
        <v-col
          cols="12"
        >
          <!--  {{ colori }}  -->
          <v-row class="my-4">
            <span
              :class="!tipcol?'text-h2 font-light-weight ml-6':'text-h3 font-light-weight ml-6'"
              :style="!tipcol?'cursor:pointer;color:#4caf50':'cursor:pointer;color:#ccc'"

              @click="tipcol=false;set_tipcol()"
            >Monocolore</span>
            <span
              :class="tipcol?'text-h2 font-light-weight ml-6':'text-h3 font-light-weight ml-6'"
              :style="tipcol?'cursor:pointer;color:#4caf50':'cursor:pointer;color:#ccc'"

              @click="tipcol=true;set_tipcol()"
            ><b>Multicolore</b></span>
          </v-row>

          <!-- <v-switch
            v-model="tipcol"
            class="ml-4"
            :label="`Multicolore `"
            @change="set_tipcol"
          >
            <template v-slot:label>
              <span
                v-if="tipcol"
                class="text-h2 font-light-weight ml-6"
                style="color:#4caf50"
              ><b>Multicolore</b></span>
              <span
                v-else
                class="text-h2 font-light-weight ml-6"
                style="color:#888"
              >Monocolore</span>
            </template>
          </v-switch> -->

          <v-row>
            <v-col
              cols="12"
            >
              <v-form
                ref="form"
                v-model="validForm"
              >
                <v-row
                  v-for="(piece,idx) in toColorize"
                  :key="`piece_${idx}`"
                  justify="center"
                  class="ma-0 pa-0"
                >
                  <v-col class="text-md-end my-0 py-0          ">
                    {{ piece.lbl }}
                  </v-col>
                  <v-col
                    md="10"
                    cols="12"
                    class="my-0 py-0"
                  >
                    <!--
                    {{ order.lens }}<hr>
                    {{ colori.filter(item => (item.compo === piece.compo && item.tipcompo === piece.tipcompo && item.valid_on.includes(order.lens.calibr.split('-')[0]))) }}
                   -->
                    <v-autocomplete
                      v-model="steporder[piece.var]"
                      :items="piece.compo!='FRON'?colori.filter(item => (item.compo === piece.compo && item.tipcompo === piece.tipcompo)):colori.filter(item => (item.compo === piece.compo && item.tipcompo === piece.tipcompo && item.valid_on.includes(order.lens.calibr.split('-')[0])))"
                      :rules="[rules.required]"
                      outlined
                      color="blue-grey lighten-2"
                      label=""
                      item-text="finder"
                      return-object
                      clearable
                      class="my-0 py-0 text-body-1"
                      dense
                    >
                      <template v-slot:selection="data">
                        <v-avatar
                          rounded
                          left
                        >
                          <v-img
                            :src="`./img/COL/${$linea().label}_${data.item.numcol}.png`"
                            contain
                          />
                        </v-avatar>
                        <span class="pl-4">{{ data.item.numcol }} {{ data.item.codcol }} {{ data.item.coldesc }}</span>
                      </template>
                      <template
                        v-slot:item="data"
                      >
                        <v-list-item-avatar
                          rounded
                          width="30"
                        >
                          <v-img
                            :alt="` avatar`"
                            :src="`./img/COL/${$linea().label}_${data.item.numcol}.png`"
                            :lazy-src="'./img/noimage.jpg'"
                            contain
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            class="pl-4"
                            v-text="`${data.item.numcol} ${data.item.codcol} ${data.item.coldesc}` "
                          />
                          <v-list-item-subtitle class="d-none">
                            ./img/COL/{{ $linea().label }}_{{ data.item.numcol }}.png
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-btn
      color="primary"
      :disabled="!validForm "
      @click="setColCompo"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Step4',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {

        steporder: {},
        colori: [],
        // colori_clp: [],
        tipcol: false,
        validForm: false,
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      toColorize () {
        /**
         *  dogma frontale non più valido dal 05.03.2026 in accordo con valentina
         *    se joy  tipcompo=44
         *    se joybaby tipcompo=34
         * this.order?.lens?.calibr?.split('-')[1]
         */
        // var tpcmp = '44'
        var taglia = this.order.lens?.calibr?.split('-')[0]
        var tpcmp
        switch (taglia) {
          case 'XS':
            tpcmp = '36'
            break
          case 'S':
            tpcmp = '38'
            break
          case 'M':
            tpcmp = '40'
            break
          case 'L':
            tpcmp = '42'
            break
          case 'XL':
            tpcmp = '44'
            break
          case 'XXL':
            tpcmp = '48'
            break
        }

        if (this.tipcol) {
          return [
            { compo: 'FRON', tipcompo: tpcmp, lbl: 'FRONTALE', var: 'col_ponte' },
            { compo: 'ASTE', tipcompo: this.order.vlaste.tipcompo, lbl: 'ASTA DX', var: 'col_astadx' },
            { compo: 'ASTE', tipcompo: this.order.vlaste.tipcompo, lbl: 'ASTA SX', var: 'col_astasx' },

          ]
        } else {
          return [
            { compo: 'FRON', tipcompo: tpcmp, lbl: 'MONTATURA', var: 'col_ponte' },

          ]
        }
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     console.log('Order changed from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          console.log('load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (this.colori.length === 0) {
            this.loadColCompo()
          }

          this.tipcol = this.steporder.tipcol
        }
      },
      nextStep () {
        if (!this.validForm) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        this.$emit('prevStep', this.step)
      },
      loadColCompo () {
        this.loading = true
        engine.get_colcompo(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            this.colori = result.data
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })
      },
      set_tipcol () {
        this.steporder.tipcol = this.tipcol
      },
      setColCompo () {
        // colore terminale
        var colTermin = this.colori.filter(item => (item.compo === 'TERM' && item.tipcompo === this.steporder.vlterm.tipcompo))
        if (colTermin.length > 1) {
          alert('indicare colore terminale sulle annotazione')
        }
        if (colTermin.length === 1) {
          this.steporder.col_termin = colTermin[0]
        }

        if (!this.tipcol) {
          this.steporder.col_astadx = this.steporder.col_ponte
          this.steporder.col_astasx = this.steporder.col_ponte
        }
        this.nextStep()
      },

    },
  }
</script>
